import React from 'react';
import Fitness1 from '../Images/Fitness1.PNG';
import Fitness2 from '../Images/Fitness2.PNG';
import Fitness3 from '../Images/Fitneaa3.PNG';

const Fitness = () => {
    return (
        <div>
            <h1 className='text-4xl bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 text-5xl font-bold'>Robinho-Fitness trainer Academy</h1>

            <div className='grid lg:grid-cols-2 justify-center items-center mt-24'>

                <div className='grid justify-center items-center'>
                    <div class="carousel mx-auto w-3/4 h-56">
                        <div id="slide1" class="carousel-item relative w-full">
                            <img src={Fitness1} class="w-full" />
                            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                <a href="#slide3" class="btn btn-circle">❮</a>
                                <a href="#slide2" class="btn btn-circle">❯</a>
                            </div>
                        </div>
                        <div id="slide2" class="carousel-item relative w-full">
                            <img src={Fitness2} class="w-full" />
                            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                <a href="#slide1" class="btn btn-circle">❮</a>
                                <a href="#slide3" class="btn btn-circle">❯</a>
                            </div>
                        </div>
                        <div id="slide3" class="carousel-item relative w-full">
                            <img src={Fitness3} class="w-full" />
                            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                                <a href="#slide2" class="btn btn-circle">❮</a>
                                <a href="#slide1" class="btn btn-circle">❯</a>
                            </div>
                        </div>
                    </div>
                    <div className='mt-3'>
                        <button className='btn btn-primary mx-auto mr-2 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none'><a target='blank' href="https://gym-body-builder.firebaseapp.com/">Live site</a></button>
                        <button className='btn btn-primary mx-auto ml-2 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none'> <a target='blank' href="https://github.com/Sarfaraj116/independent-service-provider">Code</a> </button>
                    </div>
                </div>
                <div>
                    <h1 className='text-3xl mb-9'>Overview Of The Project</h1>
                    <ul className='list-disc text-start'>
                        <li>A healthcare-related website where clients can book their tour.You can see all the services.</li>
                        <li>2 different types of Login sytems 1. Email and Password 2. Google Sign In</li>
                        <li>Autenticated Users can see appointment</li>
                        <li>React Router has been used to navigate different components.</li>
                        <li>Total 5 Routes have been Created to Visit 5 different links and 2 Private Route Created</li>
                        <li>It has authentication and a dynamic route system.</li>
                        <li>This is a responsive website.</li>
                        <li>This is mainly a frontend website.</li>
                    </ul>
                    <h1 className='text-3xl mt-3'>Technology Used</h1>
                    <p>HTML, CSS, Bootstrap5, React, Firebase</p>
                </div>

            </div>

        </div>
    );
};

export default Fitness;